import { render, staticRenderFns } from "./wx-invite.vue?vue&type=template&id=62929946&"
import script from "./wx-invite.vue?vue&type=script&lang=js&"
export * from "./wx-invite.vue?vue&type=script&lang=js&"
import style0 from "./wx-invite.vue?vue&type=style&index=0&id=62929946&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports